import { BodyOf } from "../../core/api";
import { createMutationGroup } from "../../core/api/mutations";
import { SavedReportId, ScheduledSavedReportId } from "../../shared/schema/schema";

type ScheduledSavedReportParams = BodyOf<"post", "./saved_report/:savedReportId/scheduled">;
type ScheduledSavedReportToggleActivate = BodyOf<
  "put",
  "./scheduled_saved_report/:scheduledSavedReportId"
>;

export default createMutationGroup(({ api, createMutation }) => ({
  createSchedule: (savedReportId: SavedReportId) =>
    createMutation({
      mutationFn: (body: ScheduledSavedReportParams) =>
        api.post("./saved_report/:savedReportId/scheduled", {
          path: { savedReportId },
          body,
        }),
    }),

  createStandardSchedule: (standardReportId: number) =>
    createMutation({
      mutationFn: (body: ScheduledSavedReportParams) =>
        api.post("./standard_reports/:standardReportId/scheduled", {
          path: { standardReportId },
          body,
        }),
    }),

  toggleSchedule: (scheduledSavedReportId: ScheduledSavedReportId) =>
    createMutation({
      mutationFn: (body: ScheduledSavedReportToggleActivate) =>
        api.put("./scheduled_saved_report/:scheduledSavedReportId", {
          path: { scheduledSavedReportId },
          body,
        }),
    }),
}));
